
import { BuyNowLead, BuyNowLeadResponse, ILeadValidationRequest, ILeadValidationResponse } from './../../../../../interfaces/credit-application.interface';
import { checkout_Info, DynamicYieldEventName, FormActualName, PreQualFormEventConstant, vehicle_Info } from './../../../../../enum/analytics.enum';
import { IPreQualEvent } from './../../../../../interfaces/analytics.interface';
import { PreQualComponentLoaded, PreQualFormEvents } from './../../../../../actions/analytics.action';
import { AnalyticsEventService } from './../../../../../services/analytics-event.service';
import { AnalyticsBuynowEventService } from './../../../../../services/analytics-buynow-event.service';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Component, OnInit, Inject, ChangeDetectorRef, HostListener } from '@angular/core';
import {
  CreditApplicationConfig, IUserPreferredCoordinates, LookupMappingInformation,
  PreQualLeadInfo
} from './../../../../../interfaces/credit-application-config.interface';
import { IZipCodeRequest } from './../../../../../interfaces/IZipCode.interface';
import { CustomValidator } from './../../../../../utils/customValidatorDOB';
import { IConfig, IDescriptionValuePair } from './../../../../../interfaces/config.interface';
import { CreditAppService } from './../../../../../services/credit-app.service';
import { getLookupMappings, isIEorEdge, getBackButton, getLeadValidationInfo } from './../../../../../utils/utils.functions';
import { PrequalOutcome } from '../../../../../interfaces/prequal-response.interface';
import { ComponentName } from './../../../../../enum/component-name.enum';
import { PreQualificationResponseType } from '../../../../../interfaces/prequalification-response.interface';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { BingMapsService } from '../../../../../services/bing-maps.service';
import {
  ILeadInfo, IStoreInfo, ITealiumSettings, IVehicles,
  LeadFormConfig, LeadFormModalService
} from '@autonation/dt-an-getlowerpriceleadform-lib';
import { DynamicYieldService } from 'projects/dt-an-creditapplication-lib/src/lib/services/dynamicYield.service';
import { StateService } from '../../../../../services/state.service';
import { DomSanitizer } from '@angular/platform-browser';
import { IComponentDetails } from 'projects/dt-an-creditapplication-lib/src/lib/interfaces/component-details.interface';
import { ComponentGroup } from 'projects/dt-an-creditapplication-lib/src/lib/enum/component-group.enum';
import { StepComponent } from '../../stepcomponent.class';
import { PersonalInfoComponent } from '../../personal-info/personal-info.component';
import { StepType } from 'projects/dt-an-creditapplication-lib/src/lib/enum/step-type.enum';
import { NextComponentService } from 'projects/dt-an-creditapplication-lib/src/lib/services/next-component.service';
import { PriceDetailsModalComponent } from '../../price-details-modal/price-details-modal.component';
import { BaseTooltipModalComponent } from '../../base-tooltip-modal/base-tooltip-modal.component';
import { AnModalService } from '@autonation/dt-an-components-lib/an-modal';
import { ChromeVehicleInformation } from 'projects/dt-an-creditapplication-lib/src/lib/interfaces/ChromeVehicleInformation.interface';
import { FormInfoService } from 'projects/dt-an-creditapplication-lib/src/lib/services/form-info.service';
import { CommonModule } from '@angular/common';
import { HeapIoService } from '../../../../../services/heap-io.service';

@Component({
  selector: 'dt-prequal',
  templateUrl: './prequal.component.html',
  styleUrls: ['./prequal.component.scss'],
  standalone: false
})
export class PrequalComponent implements OnInit {
  Microsoft: any;
  isFormPristine = true;
  dobMask = [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];
  ssnMask = [/\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
  phoneMask = ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
  phonePattern = '^[(]{1}[0-9]{3}[)]{1}[ ]{1}[0-9]{3}[-]{1}[0-9]{4}$';
  datePattern = '^[0-9]{2}[/]{1}[0-9]{2}[/]{1}[0-9]{4}$';
  ssnPattern = '^[0-9]{3}[-]{1}[0-9]{2}[-]{1}[0-9]{4}$';
  ssnPattern1 = '^[0-9]{3}[-]{1}[0-9]{2}[-]{1}[0-9]{4}$';
  ssnPattern2 = '^[0-9]{9}$';
  namePattern = '^[a-zA-Z]+(([\'`\-\s][a-zA-Z])?[a-zA-Z]*)$';
  MIPattern = '^[A-Za-z]*$';
  emailPattern = '[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$';
  wordOnlyRegexp = '\\S[\\w\\s-,\\.#&\\(\\)\\+\'"\s]';
  scrubInvalidChars = '[^a-zA-Z0-9\s]';
  onlyLetterNumberAndSpacePattern = /^[a-zA-Z0-9 ]*$/;
  cityPattern = '\\S[A-Za-z\\s\s]';
  currencyOnlyPattern = /\$?[0-9](\d+)?$/;
  zipCodeMask = [/\d/, /\d/, /\d/, /\d/, /\d/];
  SCData: any;
  t3Disclaimer: any;
  win = (window as any);
  preQualForm: UntypedFormGroup;
  ssnLimit = 11;
  formSubmitAttempt = false;
  formSubmitted = false;
  ssnflag = false;
  IE = false;

  creditAppConfigData: CreditApplicationConfig;
  lookupMappingInfo: LookupMappingInformation[];
  states: IDescriptionValuePair[];
  showConfirmation: boolean;
  showJackedModal: boolean;
  outcome: PrequalOutcome;
  preQualLeadInfo: PreQualLeadInfo;
  isVinAvailable = false;
  isBuyNow = false;
  IsStandAlonePreQual = false;
  isHeadless = false;
  apiDomain = '';
  SubPage = '';
  preQualiFyMe = false;
  isHomeDelivery = true;
  istest = false;
  formStarted = false;
  preQualTranscationInfo: any;
  private analyticsEventService: AnalyticsEventService;
  submitClicked: boolean;
  coordinates: IUserPreferredCoordinates;
  mapReady = false;
  invalidVin: boolean;
  invalidVinDetails: ChromeVehicleInformation = null;
  disableEmailField = false;
  hasbackButton = true;
  azKey: string;
  bingLocations: string;
  azApi: string;
  bingKey: string;
  // ---- Start Prequal by pass DOB SSN
  IsDisplayDOBPrequal: boolean;
  IsMandatoryDOBPrequal: boolean;
  IsDisplaySSNPrequal: boolean;
  IsMandatorySSNPrequal: boolean;
  IsPreQualBypassEnabled: boolean;
  // ---- End Prequal by pass DOB SSN

  // -----Start IsStandAlonePreQual-----
  show4digitSSNStandAlonePrequal = false;
  showBirthDateStandAlonePrequal = false;
  showSSN = true;
  showBirthDate = true;
  isOrStandAlonePreQual = false;
  showSSNDOBPanel = true;
  StandalonePreQualDisclaimer: any;
  PreQualDisclaimer: any;
  isPrequalANXEnabled: boolean;
  glpVhicles: IVehicles[];
  glpStoreInfo: IStoreInfo;
  glpTealiumConfig: ITealiumSettings;
  getLowerPriceConfig: LeadFormConfig;
  openLowerPriceModal: boolean = false;
  // -----End IsStandAlonePreQual-----

  isLoggedIn: boolean = false;
  isMakeFLag: boolean = false;
  isYearFLag: boolean = false;
  isModelFLag: boolean = false;
  isTrimFLag: boolean = false;
  isEnableNextFlag: boolean = false;
  ymmtObj: any;
  isShowLeadTriggered = false;
  isDeepLink: boolean = false;
  isVoiVinAvailable: any;
  isLowerpriceModalEnabledFlag: boolean = false;
  isLegacyCreditApp: boolean = false;
  isTabletView = false;
  storeDataWithDomain: any;
  isNewVDP: boolean = false;

  // Mailcheck email suggestion properties
  emailSuggestion: string | null = null;
  showEmailSuggestion: boolean = false;
  leadValidation_PhoneInvalid: boolean = false;
  leadValidation_EmailInvalid: boolean = false;  
  lastSubmittedLead:ILeadValidationRequest;

  get Address(): any {
    return this.preQualForm.get('Address');
  }

  get City(): any {
    return this.preQualForm.get('City');
  }

  get State(): any {
    return this.preQualForm.get('State');
  }

  get DOB(): any {
    return this.preQualForm.get('DOB');
  }

  get SSN(): any {
    return this.preQualForm.get('SSN');
  }
  get Zipcode(): any {
    return this.preQualForm.get('Zipcode');
  }
  public get firstName(): string {
    if ((this.isBuyNow || this.IsStandAlonePreQual) && this.config.Sitecore) {
      return this.config.Sitecore.PreQualLeadInfo.firstName || '';
    }
    return '';
  }

  public get isIframe(): boolean {
    return this.config.Sitecore ? this.config.Sitecore.isIframe : null;
  }

  public get middleInitial(): string {
    if ((this.isBuyNow || this.IsStandAlonePreQual) && this.config.Sitecore) {
      return this.config.Sitecore.PreQualLeadInfo.middleInitial || '';
    }
    return '';
  }


  public get lastName(): string {
    if ((this.isBuyNow || this.IsStandAlonePreQual) && this.config.Sitecore) {
      return this.config.Sitecore.PreQualLeadInfo.lastName || '';
    }
    return '';
  }


  public get email(): string {
    if ((this.isBuyNow || this.IsStandAlonePreQual) && this.config.Sitecore) {
      return this.config.Sitecore.PreQualLeadInfo.email || '';
    }
    return '';
  }

  public get phoneNumber(): string {
    if ((this.isBuyNow || this.IsStandAlonePreQual) && this.config.Sitecore) {
      return this.PhoneNumberUpdate(this.config.Sitecore.PreQualLeadInfo.phone) || '';
    }
    return '';
  }

  get zipcode(): any {
    if ((this.isBuyNow || this.IsStandAlonePreQual) && this.config.Sitecore) {
      return this.config.Sitecore.PreQualLeadInfo.zipcode || '';
    }
    return '';
  }



  PhoneNumberUpdate(phone) {
    if (phone && phone !== undefined && phone !== null) {
      let p = phone.match(/\d/g);
      p = p.join('');
      return '(' + p.substr(0, 3) + ') ' + p.substr(3, 3) + '-' + p.substr(6, 4);
    }
    return '';
  }

  constructor(
    private fb: UntypedFormBuilder,
    @Inject('config') public config: IConfig,
    private creditAppService: CreditAppService,
    private analyticsEventSvc: AnalyticsEventService,
    private analyticsBuynowEventSvc: AnalyticsBuynowEventService,
    private cd: ChangeDetectorRef,
    private leadFormModalService: LeadFormModalService,
    private ngxService: NgxUiLoaderService,
    private readonly dyService: DynamicYieldService,
    private stateService: StateService,
    public sanitizer: DomSanitizer,
    private nextComponentService: NextComponentService,
    private modalService: AnModalService,
    private formInfoService: FormInfoService,
    private readonly heapIoService: HeapIoService,
  ) {
    this.cookieAndIframeCheck();
    document.addEventListener('GET_YMMT_VEHICLE_SELECTION', (eventData: any) => {
      if (eventData?.detail?.make !== '') {
        this.isMakeFLag = true;
      }
      if (eventData?.detail?.year !== '') {
        this.isYearFLag = true;
      }
      if (eventData?.detail?.model !== '') {
        this.isModelFLag = true;
      }
      if ((eventData?.detail?.isTrimAvailable === true && eventData?.detail?.trim !== '') || eventData?.detail?.isTrimAvailable === false) {
        this.isTrimFLag = true;
      }
      if (this.isMakeFLag && this.isYearFLag && this.isModelFLag && this.isTrimFLag) {
        this.isEnableNextFlag = true;
        this.ymmtObj = {
          make: eventData?.detail?.make,
          year: eventData?.detail?.year,
          model: eventData?.detail?.model,
          trim: eventData?.detail?.trim,
          stockType: eventData?.detail?.selectedVehicleCondition === 'new' ? 0 : 1,
          vehicleImage: eventData?.detail?.vehicleImage ? eventData.detail.vehicleImage : ''
        }
      }
    });
  }

  /* istanbul ignore next */
  cookieAndIframeCheck() {
    const posIdx = window.location.href.toString().toLowerCase().indexOf('iframe=true');
    if (!navigator.cookieEnabled && posIdx !== -1) {
      const contentElem = document.querySelector('.standAlonePrequalContainer') as any;
      contentElem.style.display = 'none';
      const vin = this.getVINNuberfromURL(window.location.pathname);
      window.location.assign(this.config.SitecoreDomain + '/credit-application/unable-to-load/' + window.location.search + vin);
    }
  }

  ngOnInit() {
    this.isTabletView = window.innerWidth < 992;
    try {
      if ((window as any).buynow) {
        (window as any).buynow.navigation.hideNext();
      }
    } catch (e) {/* istanbul ignore next */
      console.log(e);
    }


    this.isNewVDP = window.location.search.toLowerCase().indexOf('?isnewvdp=true') === -1 ? false : true;

    const inputValue = (<HTMLInputElement>document.getElementById('ANUserId')) ? (<HTMLInputElement>document.getElementById('ANUserId')).value : '';

    const enableFavorites = (<HTMLInputElement>document.getElementById('enableFavorites')) ? (<HTMLInputElement>document.getElementById('enableFavorites')).value : '';

    if (inputValue && enableFavorites && (enableFavorites == 'True' || enableFavorites == 'true')) {
      this.isLoggedIn = true;
    }

    if (
      this.config &&
      this.config.Sitecore &&
      this.config.Sitecore.CreditApplicationConfig
    ) {
      this.SCData = this.config.Sitecore.CreditApplicationConfig.PreQualificationInformation;
      this.creditAppConfigData = this.config.Sitecore.CreditApplicationConfig;
      this.lookupMappingInfo = this.config.Sitecore.LookupMappingInformation;
      this.states = getLookupMappings(this.lookupMappingInfo, 'StateCodeType');
      this.preQualLeadInfo = this.config.Sitecore.PreQualLeadInfo;
      this.isBuyNow = this.config.Sitecore.isBuyNow ? this.config.Sitecore.isBuyNow : false;
      this.IsStandAlonePreQual = this.config.Sitecore.IsStandAlonePreQual ? this.config.Sitecore.IsStandAlonePreQual : false;
      this.isLegacyCreditApp = this.config.Sitecore.isLegacyCreditApp;
      this.isHeadless = this.config.Sitecore.isHeadless ? this.config.Sitecore.isHeadless : false;
      this.SubPage = this.config.Sitecore.SubPage ? this.config.Sitecore.SubPage : '';
      this.apiDomain = this.config.Sitecore.apiDomain ? this.config.Sitecore.apiDomain : '';
      this.storeDataWithDomain = this.config.Sitecore.storeDataWithDomain ? this.config.Sitecore.storeDataWithDomain : {};
      this.isVinAvailable = this.preQualLeadInfo.vin !== '';
      this.azKey = this.config.Sitecore?.azKey ? this.config.Sitecore.azKey : '';
      this.azApi = this.config.Sitecore?.azApi ? this.config.Sitecore.azApi : '';
      this.bingKey = this.config.Sitecore?.bingKey ? this.config.Sitecore.bingKey : '';
      this.bingLocations = this.config.Sitecore?.bingLocations ? this.config.Sitecore.bingLocations : '';
      this.isHomeDelivery = this.config.Sitecore.PreQualLeadInfo.ishomedelivery || false;
      this.preQualiFyMe = this.SCData.IsPrequalSelectedByDefault;
      this.analyticsEventService = this.isBuyNow ? this.analyticsBuynowEventSvc : this.analyticsEventSvc;
      this.preQualTranscationInfo = this.config.Sitecore.PreQualTransactionInfo;
      this.coordinates = this.config.Sitecore.UserPreferredCoordinates;
      this.invalidVin = this.config.Sitecore.isBuyNowVinInValid || false;
      this.isDeepLink = this.config.Sitecore.PreQualLeadInfo._isDeepLink;
      this.isVoiVinAvailable = this.config.Sitecore.PreQualLeadInfo._isVoiVinAvailable;
      this.isLowerpriceModalEnabledFlag = this.config.Sitecore.isLegacyCreditApp && !this.isVinAvailable && this.isVoiVinAvailable === null
      if (this.invalidVin) {
        this.invalidVinDetails = this.config.Sitecore.ChromeVinDetails || null;
      }
      if (this.isVinAvailable) {
        this.isEnableNextFlag = true;
      } else if (this.isDeepLink && this.isVoiVinAvailable === null) {
        this.isEnableNextFlag = true;
      }
      // -----Start IsStandAlonePreQual-----
      this.standAlonePreQualSetup();
      // -----End IsStandAlonePreQual-----
      this.isPrequalANXEnabled = this.config.Sitecore.ANXTransactionFlags.isPreQualificationEnabled;

      if (!this.isShowLeadTriggered) {
        this.isShowLeadTriggered = true;

        if (!this.config.Sitecore.PreQualLeadInfo.leadid && !this.isIframe && !this.isLoggedIn) {
          if (this.config.Sitecore.IsUnlockedPriceLower) {
            this.leadFormModalService.open(true);
            this.openLowerPriceModal = true;
          }
        }

      }

      if (this.apiDomain) {
        this.t3Disclaimer = this.sanitizer.bypassSecurityTrustHtml(this.SCData.T3Disclaimer);
      }
      if (this.isBuyNow) {
        this.heapIoService.trackPageview('contact-information');
      }
    }

    if ((this.isBuyNow || this.IsStandAlonePreQual) && this.config && this.config.Sitecore && !this.config.Sitecore.IsAzureMapsEnabled) {
      this.loadBingApi();
    }
    /* istanbul ignore next */
    this.PreQualByPassDOBSSN();
    this.setupFormData();

    this.setupTealiumInitDatEvent();

    this.IE = isIEorEdge();

    this.updateFormValidators();

    this.onChanges();

    if (this.preQualTranscationInfo && this.preQualTranscationInfo.length > 0) {
      if (this.preQualTranscationInfo !== null && this.preQualTranscationInfo[0] !== undefined) {
        const amount = Number(this.preQualTranscationInfo[0].Amount || 0);
        if (amount > 0) {
          const origin = `${(window as any).location.origin}`;
          const data = {
            type: 'StandAloneSubmitted',
            subType: 'Prequal',
            leadInfo: {
              FirstName: this.preQualLeadInfo.firstName,
              LastName: this.preQualLeadInfo.lastName,
              EmailAddress: this.preQualLeadInfo.email,
              HomePhone: this.preQualLeadInfo.phone,
              ZipCode: this.preQualLeadInfo.zipcode
            },
            prequalAmt: amount
          };
          (window as any).postMessage(data, origin);
          this.mapSuccess(amount);
        } else {
          this.mapFailure();
        }
      }
    }

    if (this.apiDomain !== '') {
      (window as any).azKey = this.azKey;
      (window as any).azApi = this.azApi;
      (window as any).bingLocations = this.bingLocations;
      (window as any).bingKey = this.bingKey;
      this.loadAzureMaps();
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    if (window.innerWidth < 992) {
      this.isTabletView = true
    }
  }
  getVINNuberfromURL(path: string) {
    /* istanbul ignore next */
    var vin = path && path.includes("/pre-qualification/") ? path.replace('/pre-qualification/', '') : '';
    return vin && vin != "" ? '&vin=' + vin : '';
  }

  updateFormValidators() {
    if (!this.isBuyNow) {
      this.makeAddressRequired();
      this.makeCityRequired();
      this.makeStateRequired();
      if (this.IsStandAlonePreQual) {
        this.standAloneQualValidationSetup();
      } else {
        this.makeDOBRequired();
        this.makeSSNRequired();
      }
      this.preQualForm.updateValueAndValidity();
    } else {
      if (this.isHomeDelivery || this.preQualiFyMe) {
        this.makeAddressRequired();
        this.makeCityRequired();
        this.makeStateRequired();
      }
      if (this.preQualiFyMe) {
        this.makeDOBRequired();
        this.makeSSNRequired();
      }
      this.preQualForm.updateValueAndValidity();
    }
  }

  standAloneQualValidationSetup() {
    if (this.isOrStandAlonePreQual) {
      this.makeSSNOptional();
      this.makeDOBOptional();
      this.preQualForm.setValidators([CustomValidator.optionalValidationDOBSSN]);
    } else {
      if (this.show4digitSSNStandAlonePrequal) {
        this.makeSSNRequired();
      }
      if (this.showBirthDateStandAlonePrequal) {
        this.makeDOBRequired();
      }
    }
  }

  setupFormData() {
    this.preQualForm = this.fb.group({
      FirstName: [
        this.firstName, [Validators.required, Validators.minLength(2), Validators.maxLength(32), Validators.pattern(this.namePattern)]
      ],
      MI: [this.middleInitial, [
        Validators.minLength(0),
        Validators.maxLength(1),
        Validators.pattern(this.MIPattern)
      ]],
      LastName: [
        this.lastName, [Validators.required, Validators.minLength(2), Validators.maxLength(65), Validators.pattern(this.namePattern)]
      ],
      Email: [
        this.email, [Validators.required, Validators.email, Validators.pattern(this.emailPattern)]
      ],
      Phone: [
        this.phoneNumber, [Validators.minLength(14), Validators.maxLength(14), Validators.required, Validators.pattern(this.phonePattern), CustomValidator.areaCodeValidator]
      ],
      Zipcode: [
        this.zipcode,
        [Validators.required, Validators.minLength(5)]
      ],
      Address: [
        (this.isBuyNow || this.IsStandAlonePreQual) && this.config.Sitecore ? this.config.Sitecore.PreQualLeadInfo.address : '',
        [Validators.minLength(2), Validators.maxLength(68), Validators.pattern(this.wordOnlyRegexp + '{0,68}')]
      ],
      Address2: [
        (this.isBuyNow || this.IsStandAlonePreQual) && this.config.Sitecore ? this.config.Sitecore.PreQualLeadInfo.address2 : '',
        [Validators.pattern(this.onlyLetterNumberAndSpacePattern)]
      ],
      City: [
        (this.isBuyNow || this.IsStandAlonePreQual) && this.config.Sitecore ? this.config.Sitecore.PreQualLeadInfo.city : '',
        [Validators.maxLength(38), Validators.pattern(this.cityPattern + '{0,38}')]
      ],
      State: [
        (this.isBuyNow || this.IsStandAlonePreQual) && this.config.Sitecore.PreQualLeadInfo.state ? this.config.Sitecore.PreQualLeadInfo.state : '',
      ],
      DOB: !this.config.Sitecore.isLegacyCreditApp ? [
        '', [Validators.minLength(8), Validators.maxLength(10), Validators.pattern(this.datePattern),
        CustomValidator.DOBValidator]
      ] : null,


      SSN: !this.config.Sitecore.isLegacyCreditApp ? [
        '', [Validators.minLength(this.ssnLimit), Validators.maxLength(this.ssnLimit), Validators.pattern(this.ssnPattern),
        CustomValidator.SSNValidator]
      ] : '',
      MortgageRent: [
        '',
        [
          ...this.IsStandAlonePreQual ? [Validators.required] : [],
          Validators.maxLength(7),
          Validators.pattern(this.currencyOnlyPattern)
        ]
      ],
      AnnualIncome: [
        '',
        [
          ...this.IsStandAlonePreQual ? [Validators.required] : [],
          Validators.maxLength(12),
          Validators.pattern(this.currencyOnlyPattern)
        ]
      ],
      HomeDelivery: this.isHomeDelivery,
      PreQualiFyMe: this.preQualiFyMe
    });

    this.formValueChangeEvents();

    setTimeout(() => {
      if ((this.isBuyNow || this.IsStandAlonePreQual) && this.config.Sitecore && this.config.Sitecore.PreQualLeadInfo.zipcode) {
        this.preQualForm.get('Zipcode').updateValueAndValidity({
          emitEvent: true,
          onlySelf: true
        });
      }
    });
  }

  formValueChangeEvents() {
    this.preQualForm.get('PreQualiFyMe').valueChanges.subscribe(value => {
      this.preQualiFyMe = value;
      if (value) {
        this.makeAddressRequired();
        this.makeCityRequired();
        this.makeStateRequired();
        this.makeDOBRequired();
        this.makeSSNRequired();
        this.makeAnnualMortgageRentRequired();
        this.loadAzureMaps();

        const selectPrequalifyData: IPreQualEvent = {
          componentName: ComponentName.PreQualComponent,
          data: this.preQualLeadInfo,
          isVinAvailable: this.isVinAvailable,
          isBuyNowPrequalSelected: this.preQualiFyMe,
          type: PreQualFormEventConstant.SelectPrequalify
        };
        if (this.analyticsEventService) {
          this.analyticsEventService.reportAnalyticsEvent(new PreQualFormEvents(selectPrequalifyData));
        }

      } else {
        this.makeAddressOptional();
        this.makeCityOptional();
        this.makeStateOptional();
        this.makeDOBOptional();
        this.makeSSNOptional();
        this.makeAnnualMortgageOptional();
      }
      this.preQualForm.updateValueAndValidity();
    });

    this.preQualForm.get('HomeDelivery').valueChanges.subscribe(value => {
      this.isHomeDelivery = value;
      if (value) {
        this.makeAddressRequired();
        this.makeCityRequired();
        this.makeStateRequired();

        const selectDeliveryData: IPreQualEvent = {
          componentName: ComponentName.PreQualComponent,
          data: this.preQualLeadInfo,
          isVinAvailable: this.isVinAvailable,
          isBuyNowPrequalSelected: this.preQualiFyMe,
          type: PreQualFormEventConstant.SelectHomeDelivery
        };
        if (this.analyticsEventService) {
          this.analyticsEventService.reportAnalyticsEvent(new PreQualFormEvents(selectDeliveryData));
        }
      } else {
        this.makeAddressOptional();
        this.makeCityOptional();
        this.makeStateOptional();
      }
      this.preQualForm.updateValueAndValidity();
    });


    this.preQualForm.get('Zipcode').valueChanges.subscribe(async (value) => {
      this.ngxService.stopAllLoader('creditApplicationPreQual');
      this.ngxService.startLoader('creditApplicationPreQual');
      if (value !== undefined && value !== null && value.toString().length === 5) {
        const request: IZipCodeRequest = {
          zipCode: value
        };

        const zipCodeResponse = await this.creditAppService.validateZipCodeInfo(request);

        if (zipCodeResponse && zipCodeResponse.Success) {
          this.preQualForm.patchValue({
            City: zipCodeResponse.ZipCodeData.City,
            State: zipCodeResponse.ZipCodeData.StateCode
          });
          this.cd.detectChanges();
        } else if (zipCodeResponse && !zipCodeResponse.Success) {
          if (
            zipCodeResponse.ErrorCodes &&
            zipCodeResponse.ErrorCodes.length > 0
          ) {
            this.preQualForm.patchValue({
              City: '',
              State: ''
            });
            this.Zipcode.setErrors({ invalidZipCode: true });
          }
        }
      }
      this.stopLoader();
    });
  }

  loadAzureMaps() {
    setTimeout(() => {
      if (this.config && this.config.Sitecore
        && this.config.Sitecore.IsAzureMapsEnabled
        && (this.isBuyNow || this.standAlonePreQualSetup)) {
        const addrElem = document.getElementById('Address');
        if (addrElem) {
          /* istanbul ignore next */
          addrElem.classList.add('azure-maps-auto-suggest');
        }

        (window as any)
          .AzureMapsLoaded({
            container: 'azure-maps-auto-suggest', latitude: this.coordinates.Latitude,
            longitude: this.coordinates.Longitude, address: 'Address', city: 'city', state: 'state', zip: 'zip_code', cfrom: 'prequal'
          });
      }
    }, 1000);

  }

  onChanges(): any {
    const tealiumVehicleInfo: any = (window as any).buynow && (window as any).buynow.Tealium
      ? (window as any).buynow.Tealium.vehicleInfo || {}
      : {};
    Object.keys(this.preQualForm.controls).forEach(field => {
      const control = this.preQualForm.get(field);
      control.valueChanges.subscribe(val => {
        if (!this.formStarted && val !== undefined && control.dirty) {
          const formStartedData: IPreQualEvent = {
            componentName: ComponentName.PreQualComponent,
            data: this.preQualLeadInfo,
            isVinAvailable: this.isVinAvailable,
            type: PreQualFormEventConstant.FormStarted
          };
          this.formStarted = true;
          if (this.isNewVDP) {
            this.dyService.track(DynamicYieldEventName.FormStartVDPPrequal, {
              form_actual_name: FormActualName.vdpPrequalification,
              enh_action: checkout_Info.enh_action_checkout,
              enh_checkout_option: checkout_Info.buyNow_checkout_option,
              enh_checkout_step: checkout_Info.buyNow_checkout_step,
              enh_vehic_brand: tealiumVehicleInfo.enh_vehic_brand || '',
              enh_vehic_category: tealiumVehicleInfo.enh_vehic_category || '',
              enh_vehic_discount: tealiumVehicleInfo.enh_vehic_discount
                && tealiumVehicleInfo.enh_vehic_discount.unlockedDiscount
                ? Math.abs(Number(tealiumVehicleInfo.enh_vehic_discount.unlockedDiscount)) || 0
                : 0,
              enh_vehic_id: tealiumVehicleInfo.enh_vehic_id || '',
              enh_vehic_list: (vehicle_Info.vehic_list).toUpperCase,
              enh_vehic_name: tealiumVehicleInfo.enh_vehic_name || '',
              enh_vehic_price: tealiumVehicleInfo.enh_vehic_price || '',
              enh_vehic_quantity: vehicle_Info.vehic_quantity,
              enh_vehic_variant: tealiumVehicleInfo.enh_vehic_variant || ''
            });
          } else {
            this.dyService.track(DynamicYieldEventName.FormStartPersonalDetails, {
              enh_action: checkout_Info.enh_action_checkout,
              enh_checkout_option: checkout_Info.buyNow_checkout_option,
              enh_checkout_step: checkout_Info.buyNow_checkout_step,
              enh_vehic_brand: tealiumVehicleInfo.enh_vehic_brand || '',
              enh_vehic_category: tealiumVehicleInfo.enh_vehic_category || '',
              enh_vehic_discount: tealiumVehicleInfo.enh_vehic_discount
                && tealiumVehicleInfo.enh_vehic_discount.unlockedDiscount
                ? Math.abs(Number(tealiumVehicleInfo.enh_vehic_discount.unlockedDiscount)) || 0
                : 0,
              enh_vehic_id: tealiumVehicleInfo.enh_vehic_id || '',
              enh_vehic_list: vehicle_Info.vehic_list,
              enh_vehic_name: tealiumVehicleInfo.enh_vehic_name || '',
              enh_vehic_price: tealiumVehicleInfo.enh_vehic_price || '',
              enh_vehic_quantity: vehicle_Info.vehic_quantity,
              enh_vehic_variant: tealiumVehicleInfo.enh_vehic_variant || ''
            });
          }
          if (this.analyticsEventService) {
            this.analyticsEventService.reportAnalyticsEvent(new PreQualFormEvents(formStartedData));
          }
        }
      });
    });
  }

  setupTealiumInitDatEvent() {
    const data: IPreQualEvent = {
      componentName: ComponentName.PreQualComponent,
      data: this.preQualLeadInfo,
      isVinAvailable: this.isVinAvailable,
      isBuyNowPrequalSelected: this.preQualiFyMe,
      type: PreQualFormEventConstant.FormLoad
    };
    if (this.analyticsEventService) {
      this.analyticsEventService.reportAnalyticsEvent(new PreQualComponentLoaded(data));
    }
  }

  makeAddressRequired() {
    this.Address.setValidators([
      Validators.required,
      Validators.minLength(2),
      Validators.maxLength(68),
      Validators.pattern(this.wordOnlyRegexp + '{0,68}')
    ]);
    this.Address.updateValueAndValidity();
  }

  makeAddressOptional() {
    this.Address.setValidators([
      Validators.minLength(2),
      Validators.maxLength(68),
      Validators.pattern(this.wordOnlyRegexp + '{0,68}')
    ]);
    this.Address.updateValueAndValidity();
  }

  makeCityRequired() {
    this.City.setValidators([
      Validators.required,
      Validators.maxLength(38),
      Validators.pattern(this.cityPattern + '{0,38}')
    ]);
    this.City.updateValueAndValidity();
  }

  makeCityOptional() {
    this.City.setValidators([
      Validators.maxLength(38),
      Validators.pattern(this.cityPattern + '{0,38}')
    ]);
    this.City.updateValueAndValidity();
  }

  makeStateRequired() {
    this.State.setValidators([
      Validators.required
    ]);
    this.State.updateValueAndValidity();
  }

  makeStateOptional() {
    this.State.setValidators([]);
    this.State.updateValueAndValidity();
  }

  makeDOBRequired() {
    if (this.IsPreQualBypassEnabled) {
      if (this.IsMandatoryDOBPrequal && this.IsDisplayDOBPrequal) {
        this.MakeRequiredDOB();
      } else {
        this.makeDOBOptional();
      }
    } else {
      this.MakeRequiredDOB();
    }
  }

  MakeRequiredDOB() {
    this.DOB.setValidators([
      Validators.required,
      Validators.minLength(8),
      Validators.maxLength(10),
      Validators.pattern(this.datePattern),
      CustomValidator.DOBValidator
    ]);
    this.DOB.updateValueAndValidity();
  }

  makeDOBOptional() {
    this.DOB.setValidators([
      Validators.minLength(8),
      Validators.maxLength(10),
      Validators.pattern(this.datePattern),
      CustomValidator.DOBValidator
    ]);
    this.DOB.updateValueAndValidity();
  }

  makeSSNRequired() {
    if (this.IsPreQualBypassEnabled) {
      if (this.IsMandatorySSNPrequal && this.IsDisplaySSNPrequal) {
        this.MakeRequiredSSN();
      } else {
        this.makeSSNOptional();
      }
    } else {
      this.MakeRequiredSSN();
    }
  }

  makeAnnualMortgageRentRequired() {
    this.preQualForm.get('MortgageRent').setValidators([
      Validators.required, Validators.maxLength(7), Validators.pattern(this.currencyOnlyPattern)
    ]);
    this.preQualForm.get('MortgageRent').updateValueAndValidity();

    this.preQualForm.get('AnnualIncome').setValidators([
      Validators.required, Validators.maxLength(12), Validators.pattern(this.currencyOnlyPattern)
    ]);

    this.preQualForm.get('MortgageRent').updateValueAndValidity();
    this.preQualForm.get('AnnualIncome').updateValueAndValidity();
  }

  makeAnnualMortgageOptional() {
    this.preQualForm.get('MortgageRent').setValidators([
      Validators.maxLength(7), Validators.pattern(this.currencyOnlyPattern)
    ]);
    this.preQualForm.get('MortgageRent').updateValueAndValidity();

    this.preQualForm.get('AnnualIncome').setValidators([
      Validators.maxLength(12), Validators.pattern(this.currencyOnlyPattern)
    ]);

    this.preQualForm.get('MortgageRent').updateValueAndValidity();
    this.preQualForm.get('AnnualIncome').updateValueAndValidity();
  }

  MakeRequiredSSN() {
    this.SSN.setValidators([
      Validators.required,
      Validators.minLength(this.ssnLimit),
      Validators.maxLength(this.ssnLimit),
      Validators.pattern(this.ssnPattern),
      CustomValidator.SSNValidator
    ]);
    this.SSN.updateValueAndValidity();
  }

  makeSSNOptional() {
    this.SSN.setValidators([
      Validators.minLength(this.ssnLimit),
      Validators.maxLength(this.ssnLimit),
      Validators.pattern(this.ssnPattern),
      CustomValidator.SSNValidator
    ]);
    this.SSN.updateValueAndValidity();
  }

  validateDOB() {
    if (this.IsStandAlonePreQual && this.preQualForm.get('SSN').touched && this.preQualForm.get('SSN').valid) {
      this.makeDOBOptional();
    }
  }

  validateSSN() {
    if (this.IsStandAlonePreQual && this.preQualForm.get('DOB').touched && this.preQualForm.get('DOB').valid) {
      this.makeSSNOptional();
    }
  }

  toggleAriaPress(e: any) {
    if (this.preQualForm.get('SSN').value !== '') {
      if (e.target.ariaPressed === 'true') {
        e.target.ariaPressed = 'false';
      } else {
        e.target.ariaPressed = 'true';
      }
    }
  }

  checkSecureSSN(item: boolean) {
    if (item) {
      if (this.isBuyNow || (this.IsStandAlonePreQual && this.preQualForm.get('SSN').value !== '')) {
        this.ssnflag = !this.ssnflag;
        if (this.ssnflag) {
          this.ssnMask = [/\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
          this.ssnLimit = 11;
          this.ssnPattern = this.ssnPattern1;
          this.setSSNValidator(this.ssnPattern, this.ssnLimit);
          this.preQualForm.updateValueAndValidity();
          this.preQualForm.controls.SSN.setValue(this.maskSSN2(this.preQualForm.controls.SSN.value));
          this.preQualForm.updateValueAndValidity();
        } else {
          this.ssnMask = [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];
          this.ssnLimit = 9;
          this.ssnPattern = this.ssnPattern2;
          this.setSSNValidator(this.ssnPattern, this.ssnLimit);
          this.preQualForm.updateValueAndValidity();
          this.preQualForm.controls.SSN.setValue(this.maskSSN(this.preQualForm.controls.SSN.value));
          this.preQualForm.updateValueAndValidity();
        }
      }
    }
  }

  setSSNValidator(pattern, mxlimit) {
    this.preQualForm.controls.SSN.clearValidators();
    this.preQualForm.controls.SSN.setValidators([
      Validators.required,
      Validators.minLength(mxlimit),
      Validators.maxLength(mxlimit),
      Validators.pattern(pattern),
      CustomValidator.SSNValidator,
    ]);
    this.preQualForm.controls.SSN.updateValueAndValidity({ emitEvent: false, onlySelf: true });
  }
  // -----Start Prequal bypass ssn dob---
  PreQualByPassDOBSSN() {
    this.ByPassPrequalDOB();
    this.ByPassPrequalSSN();
  }

  ByPassPrequalDOB() {
    const disDob = document.getElementsByName('DisplayDOBPrequal');
    const disDobValue = disDob !== undefined && disDob.length > 0 ? (disDob[0] as HTMLInputElement).value.toLowerCase() : 'true';
    this.IsDisplayDOBPrequal = (disDobValue === 'true');
    const disDobMan = document.getElementsByName('MandatoryDOBPrequal');
    const dobManVal = disDobMan !== undefined && disDobMan.length > 0 ? (disDobMan[0] as HTMLInputElement).value.toLowerCase() : 'false';
    this.IsMandatoryDOBPrequal = (dobManVal === 'true');
    const enabled = document.getElementsByName('IsPreQualBypassEnabled');
    const enabledValue = enabled !== undefined && enabled.length > 0 ? (enabled[0] as HTMLInputElement).value.toLowerCase() : 'false';
    this.IsPreQualBypassEnabled = (enabledValue === 'true');
    if (this.IsPreQualBypassEnabled) {
      this.isOrStandAlonePreQual = !this.IsPreQualBypassEnabled;
    }
  }

  ByPassPrequalSSN() {
    const disSsn = document.getElementsByName('DisplaySSNPrequal');
    const disSsnValue = disSsn !== undefined && disSsn.length > 0 ? (disSsn[0] as HTMLInputElement).value.toLowerCase() : 'true';
    this.IsDisplaySSNPrequal = (disSsnValue === 'true');
    const disSsnMan = document.getElementsByName('MandatorySSNPrequal');
    const ssnManVal = disSsnMan !== undefined && disSsnMan.length > 0 ? (disSsnMan[0] as HTMLInputElement).value.toLowerCase() : 'false';
    this.IsMandatorySSNPrequal = (ssnManVal === 'true');
  }
  // -----End Prequal bypass ssn dob---
  // -----Start IsStandAlonePreQual-----

  standAlonePreQualSetup() {
    if (this.IsStandAlonePreQual && this.SCData) {
      this.setUpGetLowerPrice();
      this.show4digitSSNStandAlonePrequal = this.SCData.ShowSSNStandAlonePrequal;
      this.showBirthDateStandAlonePrequal = this.SCData.ShowBirthDateStandAlonePrequal;
      this.isOrStandAlonePreQual =
        (this.showBirthDateStandAlonePrequal && this.show4digitSSNStandAlonePrequal && !this.IsPreQualBypassEnabled) ? true : false;
      this.showSSNDOBPanel = true;

      this.showSSN = this.SCData.ShowSSNStandAlonePrequal;
      this.showBirthDate = this.SCData.ShowBirthDateStandAlonePrequal;
    } else {
      // this.show4digitSSNStandAlonePrequal = true;
      // this.showBirthDateStandAlonePrequal = true;
      this.isOrStandAlonePreQual = false;
      this.showSSNDOBPanel = this.preQualiFyMe || !this.isBuyNow;

      this.IsStandAlonePreQual = false;
      this.show4digitSSNStandAlonePrequal = false;
      this.showSSN = true;
      this.showBirthDate = true;
    }
    /* istanbul ignore next */
    if (this.SCData && this.SCData.StandalonePreQualDisclaimer) {
      const domain = this.apiDomain.replace('/pre-qualification', '');
      const html = this.SCData.StandalonePreQualDisclaimer.replace(/href="(\/[^"]*)"/g, `href="${domain}$1"`);
      this.StandalonePreQualDisclaimer = this.sanitizer.bypassSecurityTrustHtml(html);
    }

    if (this.SCData && this.SCData.PreQualDisclaimer) {
      this.PreQualDisclaimer = this.sanitizer.bypassSecurityTrustHtml(this.SCData.PreQualDisclaimer);
    }
  }

  setUpGetLowerPrice() {
    if (this.config && this.config.Sitecore && this.config.Sitecore.GetLowerPriceConfig) {
      const Data = this.config.Sitecore.GetLowerPriceConfig;
      if (Data) {
        this.getLowerPriceConfig = {
          leadFormTitle: Data.LeadFormTitle,
          leadFormSubTitle: Data.LeadFormSubTitle,
          firstNameLabel: Data.FirstNameLabel,
          lastNameLabel: Data.LastNameLabel,
          emailAddressLabel: Data.EmailAddressLabel,
          phoneNumberLabel: Data.PhoneNumberLabel,
          zipCodeLabel: Data.ZipCodeLabel,
          acceptTextCTA: Data.AcceptTextCTA,
          dismissTextCTA: Data.DismissTextCTA,
          invalidErrorMsg: Data.InvalidErrorMsg,
          requiredErrorMsg: Data.RequiredErrorMsg,
          providerId: '',
          subproviderId: '',
          invalidAreaCodeMsg: Data.invalidAreaCodeMsg,
          phonePlaceholder: Data.phonePlaceholder
        };
      }
    }
    if (this.config.Sitecore && this.config.Sitecore.TealiumSettings) {
      this.glpTealiumConfig = this.config.Sitecore.TealiumSettings;


      if (this.preQualLeadInfo && this.preQualLeadInfo.inventoryType) {
        this.glpVhicles = [{
          trim: '',
          stock: '',
          condition: this.preQualLeadInfo.inventoryType,
          vin: this.preQualLeadInfo.vin,
          model: this.preQualLeadInfo.model,
          make: this.preQualLeadInfo.make,
          year: this.preQualLeadInfo.year.toString(),
          primary: true
        }];
      }

      this.glpStoreInfo = {
        HyperionId: this.config.Sitecore.Hid ? this.config.Sitecore.Hid : (this.preQualLeadInfo != null ? this.preQualLeadInfo.HyperianId : ''),
        StoreName: this.config.Sitecore.StoreInfo != null ? this.config.Sitecore.StoreInfo.Name : ''
      };
    }
  }

  glpLeadResponse(glpLead: ILeadInfo) {
    this.preQualForm.get('FirstName').setValue(glpLead.FirstName);
    this.preQualForm.get('LastName').setValue(glpLead.LastName);
    this.preQualForm.get('Email').setValue(glpLead.EmailAddress);
    this.preQualForm.get('Phone').setValue(glpLead.HomePhone);
    this.preQualForm.get('Zipcode').setValue(glpLead.ZipCode);
    this.submitLeadId();
  }

  submitLeadId() {
    const data = {
      type: 'VehicleLeftRail_LeadCreated',
      source: 'CPC'
    };
    this.postMessage(data);
  }

  postMessage(data: any) {
    try {
      const origin = `${(window as any).location.origin}`;
      (window as any).postMessage(data, origin);
    } catch (e) {
      console.log(e);
    }
  }

  // -----End IsStandAlonePreQual-----
  maskSSN(ssn) {
    if (ssn) {
      const ssncopy = ssn;
      // if (ssncopy && ssncopy.length === 4) {
      //   ssncopy = '00000' + ssn;
      // }
      let p = ssncopy.match(/\d/g);
      p = p.join('');
      return p.substr(0, 3) + p.substr(3, 2) + p.substr(5, 4);
    }
    return '';
  }

  maskSSN2(ssn) {
    if (ssn) {
      const ssncopy = ssn;
      let p = ssncopy.match(/\d/g);
      p = p.join('');
      return p.substr(0, 3) + '-' + p.substr(3, 2) + '-' + p.substr(5, 4);
    }
    return '';
  }

  hasFocus(element: any) {
    return document.activeElement === element || element.isBlur;
  }

  checkEmailDomain() {
    this.emailFocusOut();
    const emailValue = this.preQualForm.get('Email')?.value;
    
    // Don't check if email is empty, invalid, or readonly
    if (!emailValue || this.preQualForm.get('Email').invalid || (this.isLoggedIn && this.config?.Sitecore?.PreQualLeadInfo?.email)) {
      this.showEmailSuggestion = false;
      this.emailSuggestion = null;
      return;
    }

    // Try to access Mailcheck from current window or parent window (for iframe scenarios)
    const MailcheckLib = (window as any).Mailcheck || (window.parent as any).Mailcheck;

    // Check if Mailcheck is available
    if (typeof MailcheckLib === 'undefined') {
      console.warn('Mailcheck library is not loaded');
      return;
    }

    try {
      MailcheckLib.run({
        email: emailValue,
        suggested: (suggestion: any) => {
          // Store only the domain name (e.g., 'gmail.com') instead of full email
          this.emailSuggestion = suggestion.domain;
          this.showEmailSuggestion = true;
          this.cd.detectChanges();
        },
        empty: () => {
          this.showEmailSuggestion = false;
          this.emailSuggestion = null;
          this.cd.detectChanges();
        }
      });
    } catch (error) {
      console.error('Error running Mailcheck:', error);
    }
  }

  acceptEmailSuggestion() {
    if (this.emailSuggestion && this.preQualForm.get('Email')?.value) {
      // Extract the address part (before @) from current email
      const currentEmail = this.preQualForm.get('Email').value;
      const addressPart = currentEmail.split('@')[0];
      
      // Reconstruct email with suggested domain
      const correctedEmail = `${addressPart}@${this.emailSuggestion}`;
      
      this.preQualForm.get('Email').setValue(correctedEmail);
      this.showEmailSuggestion = false;
      this.emailSuggestion = null;
      this.cd.detectChanges();
    }
  }

  closeJacked() {
    this.showJackedModal = false;
  }

  loadJacked() {
    this.formSubmitAttempt = true;
    this.showConfirmation = false;
    this.showJackedModal = true;
  }

  toggleNavigation() {
    if (this.isBuyNow) {
      try {
        if ((window as any).buynow.navigation) {
          (window as any).buynow.navigation.toggleNavigationDisableState();
        }
      } catch (e) {/* istanbul ignore next */
        console.log(e);
      }
    }
  }

  submitPreQualApplication() {
    if (this.isHeadless) {
      this.submitPreQualApplicationStandAloneHL();
    } else {
      this.submitPreQualApplicationLegacy();
    }
  }

  async submitPreQualApplicationLegacy() {
    this.preQualForm.markAllAsTouched();
    this.preQualForm.markAsDirty();
    this.preQualForm.updateValueAndValidity();
    this.formSubmitAttempt = true;

    getBackButton();
    if (this.preQualForm.valid && this.preQualForm.dirty) {
      if (this.isBuyNow && !this.preQualiFyMe) {
        const request: BuyNowLead = {
          FirstName: '',
          MiddleName: '',
          LastName: '',
          Phone: '',
          Email: '',
          Zipcode: '',
          Vin: '',
          City: '',
          State: '',
          Address: '',
          Make: '',
          Model: '',
          Year: '',
          Trim: '',
          IsVinInvalid: false
        };
        this.preQualForm.get('FirstName').setValue(this.preQualForm.get('FirstName').value.trim());
        request.FirstName = this.preQualForm.get('FirstName').value;
        this.preQualForm.get('LastName').setValue(this.preQualForm.get('LastName').value.trim());
        request.LastName = this.preQualForm.get('LastName').value;
        request.Phone = this.preQualForm.get('Phone').value.match(/\d/g).join('');
        request.Email = this.preQualForm.get('Email').value;
        if (this.preQualLeadInfo && this.preQualLeadInfo.vin) {
          request.Vin = this.preQualLeadInfo.vin;
        }
        request.IsVinInvalid = this.invalidVin;
        if (this.invalidVin && this.invalidVinDetails !== null) {
          request.Make = this.invalidVinDetails.VehicleInformation.Make;
          request.Model = this.invalidVinDetails.VehicleInformation.Model;
          request.Year = this.invalidVinDetails.VehicleInformation.Year.toString();
          request.Trim = this.invalidVinDetails.VehicleInformation.Trims[0].Value;
          request.Vin = this.invalidVinDetails.VehicleInformation.Vin;
        }
        if (this.preQualForm.get('MI').value !== null) {
          this.preQualForm.get('MI').setValue(this.preQualForm.get('MI').value.trim());
          request.MiddleName = this.preQualForm.get('MI').value;
        }
        request.Zipcode = this.Zipcode.value;
        /* istanbul ignore else */
        if (this.isHomeDelivery) {
          request.Address = this.Address.value;
          request.City = this.City.value;
          request.State = this.State.value;
          request.IsHomeDelivery = true;
        } else {
          request.IsHomeDelivery = false;
        }
        if (this.analyticsEventService) {
          this.analyticsEventService.reportAnalyticsEvent(new PreQualFormEvents({
            type: PreQualFormEventConstant.FormSubmitInitiated,
            componentName: ComponentName.PreQualComponent,
            isVinAvailable: false,
            data: {},
          } as IPreQualEvent));
        }
        this.creditAppService.BuyNowHeadlessPrefix = this.config.Sitecore?.BuyNowHeadlessPrefix || '';

                     (request.Phone !== this.config?.Sitecore?.PreQualLeadInfo?.phone);

        if(this.shouldValidateLeadRequest(request)) {
          let lead: ILeadValidationRequest = {
              firstName: request.FirstName,
              lastName: request.LastName,
              email: request.Email,
              phone: request.Phone,
              hyperionId: this.config.Sitecore.Hid ? this.config.Sitecore.Hid : this.preQualLeadInfo.HyperianId
          };
          const leadValidResponse  = await this.validateLead(lead);
          if(!leadValidResponse?.valid) {
            this.submitClicked = false; 
            return false; 
          }
          if(leadValidResponse?.validationParam?.id) {
            request.validation = leadValidResponse.validationParam;
          }          
        } else {
          request.validation = {
            enable: !this.config?.Sitecore?.CreditApplicationConfig?.PreQualificationInformation?.EnableLeadValidation ? true : false,
            id: null
          };
        }

        this.submitClicked = true;
        this.creditAppService.CreateBuyNowLead(request).subscribe((response: BuyNowLeadResponse) => {
          /* istanbul ignore else*/
          if (response.Success) {
            try {
              if (this.analyticsEventService) {
                this.analyticsEventService.reportAnalyticsEvent(new PreQualFormEvents({
                  type: PreQualFormEventConstant.LeadSubmission,
                  componentName: ComponentName.PreQualComponent,
                  isVinAvailable: this.isVinAvailable,
                  data: {}
                } as IPreQualEvent));
                this.analyticsEventService.reportAnalyticsEvent(new PreQualFormEvents({
                  type: PreQualFormEventConstant.FormSuccess,
                  componentName: ComponentName.PreQualComponent,
                  isBuyNowPrequalSelected: false,
                  isVinAvailable: false,
                  isStandAlonePrequal: this.IsStandAlonePreQual,
                  leadId: response.Value.LeadId || '',
                  data: {
                    zipcode: this.Zipcode.value
                  },
                } as IPreQualEvent));
              }
              if (this.isBuyNow) {
                this.heapIoService.track('Purchase', { dollars: 302, item: 'Buy Now' });
              }
              try {
                if ((window as any).buynow) {
                  (window as any).buynow.navigation.moveNext();
                }
                (window as any).ctaBuyNowReload.reloadView();
              } catch (e) {/* istanbul ignore next */
                console.log(e);
              }
            } catch (e) {/* istanbul ignore next */
              console.log(e);
            }
          } else {
            this.stopLoader();
            this.showJackedModal = true;
            this.toggleNavigation();
            if (this.analyticsEventService) {
              this.analyticsEventService.reportAnalyticsEvent(new PreQualFormEvents({
                type: PreQualFormEventConstant.FormFailure,
                componentName: ComponentName.PreQualComponent,
                isBuyNowPrequalSelected: false,
                isVinAvailable: false,
                data: {},
              } as IPreQualEvent));
            }
            this.submitClicked = false;
          }
        },
          error => {
            /* istanbul ignore next */
            console.log(error);
            /* istanbul ignore next */
            this.stopLoader();
            /* istanbul ignore next */
            this.showJackedModal = true;
            /* istanbul ignore next */
            this.toggleNavigation();
            /* istanbul ignore next */
            this.submitClicked = false;
            /* istanbul ignore next */
            if (this.analyticsEventService) {
              this.analyticsEventService.reportAnalyticsEvent(new PreQualFormEvents({
                type: PreQualFormEventConstant.FormFailure,
                componentName: ComponentName.PreQualComponent,
                isBuyNowPrequalSelected: false,
                isVinAvailable: false,
                data: {},
              } as IPreQualEvent));
            }
          });
      } else {
        if (this.analyticsEventService) {
          this.analyticsEventService.reportAnalyticsEvent(new PreQualFormEvents({
            type: PreQualFormEventConstant.FormSubmitInitiated,
            componentName: ComponentName.PreQualComponent,
            isVinAvailable: this.isVinAvailable,
            data: this.preQualLeadInfo,
          } as IPreQualEvent));
        }
        const ca = { ...this.creditAppService.PreQualiFication };

        this.preQualForm.get('FirstName').setValue(this.preQualForm.get('FirstName').value.replace(/'+/g, '').trim());
        ca.buyer.personalInformation.firstName = this.preQualForm.get('FirstName').value.replace(/'+/g, '').trim();
        this.preQualForm.get('LastName').setValue(this.preQualForm.get('LastName').value.replace(/'+/g, '').trim());
        ca.buyer.personalInformation.lastName = this.preQualForm.get('LastName').value.replace(/'+/g, '').trim();
        if (this.preQualForm.get('MI').value !== null) {
          this.preQualForm.get('MI').setValue(this.preQualForm.get('MI').value.trim());
          ca.buyer.personalInformation.middleName = this.preQualForm.get('MI').value;
        }
        ca.buyer.personalInformation.emailAddress = this.preQualForm.get('Email').value;
        ca.buyer.personalInformation.phoneNumber = this.preQualForm.get('Phone').value.match(/\d/g).join('');
        ca.buyer.personalInformation.dateOfBirth = this.preQualForm.get('DOB').value;
        ca.buyer.financialInformation.securityInformation.ssn = this.preQualForm.get('SSN').value;
        ca.buyer.personalInformation.income = this.preQualForm.get('AnnualIncome').value;
        ca.buyer.personalInformation.monthlyMortgage = this.preQualForm.get('MortgageRent').value;
        ca.buyer.personalInformation.currentAddress = {
          addressLine1: this.preQualForm.get('Address').value?.replace(/[^a-zA-Z0-9\s]/g, ''), //scrub invalid chars
          addressLine2: this.preQualForm.get('Address2').value?.replace(/[^a-zA-Z0-9\s]/g, ''), //scrub invalid chars
          city: this.preQualForm.get('City').value,
          postalCode: this.preQualForm.get('Zipcode').value,
          stateCode: this.preQualForm.get('State').value,
          yearsAtAddress: null,
          monthsAtAddress: null
        };
        if (this.isBuyNow) {
          ca.buyer.personalInformation.isHomeDelivery = this.preQualForm.get('HomeDelivery').value;
        }

        if (this.isVinAvailable) {
          ca.voi.make = this.preQualLeadInfo.make;
          ca.voi.year = this.preQualLeadInfo.year;
          ca.voi.model = this.preQualLeadInfo.model;
          ca.voi.vin = this.preQualLeadInfo.vin;
          ca.voi.stockType = this.preQualLeadInfo.inventoryType;
          ca.voi.hyperionId = this.config.Sitecore.Hid ? this.config.Sitecore.Hid : this.preQualLeadInfo.HyperianId;
        } else {
          ca.hideVoi = true;
        }
        if (this.invalidVin && this.isBuyNow && this.invalidVinDetails !== null) {
          ca.voi.make = this.invalidVinDetails.VehicleInformation.Make;
          ca.voi.model = this.invalidVinDetails.VehicleInformation.Model;
          ca.voi.year = this.invalidVinDetails.VehicleInformation.Year;
          ca.voi.trim = this.invalidVinDetails.VehicleInformation.Trims[0].Value;
          ca.voi.vin = this.invalidVinDetails.VehicleInformation.Vin;
          ca.voi.stockType = 'used';
        }
        ca.voi.isInvalidVin = this.invalidVin;
        if (this.preQualLeadInfo && this.preQualLeadInfo.vin) {
          ca.vin = this.preQualLeadInfo.vin || null;
        }
        if (this.preQualLeadInfo && this.preQualLeadInfo.HyperianId) {
          ca.hyperianId = this.preQualLeadInfo.HyperianId || null;
        }
        ca.isIframe = this.isIframe;




        //let leadValidadtionResponse;
        // const shouldValidate = (ca.buyer.personalInformation.emailAddress !== this.config?.Sitecore?.PreQualLeadInfo?.email) || 
        //                         (ca.buyer.personalInformation.phoneNumber !== this.config?.Sitecore?.PreQualLeadInfo?.phone);

        if(this.shouldValidateLead(ca)) {
          let lead: ILeadValidationRequest = {
              firstName: ca.buyer.personalInformation.firstName,
              lastName: ca.buyer.personalInformation.lastName,
              email: ca.buyer.personalInformation.emailAddress,
              phone: ca.buyer.personalInformation.phoneNumber,
              hyperionId: ca.voi?.hyperionId || this.config?.Sitecore?.Hid || ca.hyperianId || ''
          };          

          //if(this.isLoggedIn && this.config?.Sitecore?.PreQualLeadInfo?.email){
          const leadValidadtionResponse  = await this.validateLead(lead);
          if(!leadValidadtionResponse?.valid) {
   
            this.submitClicked = false;
            return false; 
          } 
          if(leadValidadtionResponse?.validationParam?.id) {
            ca.validation = leadValidadtionResponse.validationParam;
          }                 
        }

        this.creditAppService.BuyNowHeadlessPrefix = this.config.Sitecore?.BuyNowHeadlessPrefix || '';


        this.submitClicked = true;    
        this.creditAppService.SavePreQualification(ca, this.creditAppService?.BuyNowHeadlessPrefix !== '').subscribe((response: any) => {
          if (response && response.IsSuccess !== undefined && response.IsSuccess && response.isBuynow && response.isRedirect === true) {
            window.location.href = response.redirectURl;
          }

          else if (response.IsSuccess !== undefined && response.IsSuccess) {

            if (this.preQualLeadInfo && this.preQualLeadInfo.zipcode) {
              this.preQualLeadInfo.zipcode = this.preQualForm.get('Zipcode').value;
            }

            if (this.analyticsEventService) {
              this.analyticsEventService.reportAnalyticsEvent(new PreQualFormEvents({
                type: PreQualFormEventConstant.LeadSubmission,
                componentName: ComponentName.PreQualComponent,
                isBuyNowPrequalSelected: this.preQualiFyMe,
                isVinAvailable: this.isVinAvailable,
                data: this.preQualLeadInfo,
              } as IPreQualEvent));
            }

            if (this.preQualLeadInfo && this.preQualLeadInfo.prequalAmt) {
              this.preQualLeadInfo.prequalAmt = (ca.hideVoi && !ca.hyperianId && !ca.isIframe) ? this.setSavePrequalAmt(response.Data) : this.setPrequalAmt(response);
            }
            if (this.analyticsEventService) {
              this.analyticsEventService.reportAnalyticsEvent(new PreQualFormEvents({
                type: PreQualFormEventConstant.FormSuccess,
                componentName: ComponentName.PreQualComponent,
                isBuyNowPrequalSelected: this.preQualiFyMe,
                isVinAvailable: this.isVinAvailable,
                data: this.preQualLeadInfo,
              } as IPreQualEvent));
            }
            if (this.isBuyNow) {
              this.heapIoService.track('Purchase', { dollars: 302, item: 'Buy Now' });
              try {
                /* istanbul ignore next */
                (window as any).ctaBuyNowReload.reloadView();
                /* istanbul ignore next */
                if (!this.invalidVin && (window as any).buynow) {
                  /* istanbul ignore next */
                  (window as any).buynow.navigation.unlockLeftRail();
                }
              } catch (e) {
                /* istanbul ignore next */
                console.log(e);
              }
            }
            if (this.IsStandAlonePreQual) {
              try {
                const preQualifyStatus: IPreQualEvent = {
                  componentName: ComponentName.PreQualComponent,
                  data: this.preQualLeadInfo,
                  isVinAvailable: this.isVinAvailable,
                  // tslint:disable-next-line: max-line-length
                  type: this.preQualLeadInfo.prequalAmt > 0 ? PreQualFormEventConstant.PreQualApproved : PreQualFormEventConstant.PreQualDeclined
                };
                this.analyticsEventService.reportAnalyticsEvent(new PreQualFormEvents(preQualifyStatus));

                if (!this.isIframe && !this.config.Sitecore.PreQualLeadInfo.vin && this.config.Sitecore && this.config.Sitecore.CreditApplicationConfig) {
                  /* istanbul ignore next */
                  let url: string = this.config.Sitecore.CreditApplicationConfig.PreQualificationInformation
                    && this.config.Sitecore.CreditApplicationConfig.PreQualificationInformation.PrequalWithoutVOIRedirectsTo
                    && this.config.Sitecore.CreditApplicationConfig.PreQualificationInformation.PrequalWithoutVOIRedirectsTo.Url;

                  const searchRadius: number = this.config.Sitecore.CreditApplicationConfig.PreQualificationInformation
                    && Number(this.config.Sitecore.CreditApplicationConfig.PreQualificationInformation.PrequalWithoutVOISearchRadius);
                  /* istanbul ignore next */
                  url = url || '/cars-for-sale';

                  const prequalAmount = (ca.hideVoi && !ca.hyperianId && !ca.isIframe) ? this.setSavePrequalAmt(response) : this.setPrequalAmt(response);

                  /* istanbul ignore next */
                  if (url.indexOf('?') !== -1) {
                    url += '&';
                  } else {
                    url += '?';
                  }

                  /* istanbul ignore next */
                  // if (prequalAmount > 0) {
                  //   // round to next 10000 with 10% more
                  //   let max = Math.ceil((prequalAmount + (prequalAmount * 0.10)) / 10000) * 10000;
                  //   if (max > 100000) {
                  //     max = 100000;
                  //   } else if (max <= 5000 && max > 2000) {
                  //     max = 5000;
                  //   } else if (max < 2000) {
                  //     max = 2000;
                  //   }
                  //   url += `banner=prequal&sortdirection=1&fmn=1&fmx=${max}`;
                  // } else {
                  //   url += 'banner=prequal&sortdirection=0';
                  // }

                  url += 'banner=prequal&sortdirection=0';

                  if (searchRadius) {
                    url += `&dst=${searchRadius}`;
                  }

                  this.navigateToUrl(`${url}`);

                  // dont show confirmation page, just redirect
                  return;
                } else {
                  const origin = `${(window as any).location.origin}`;
                  const data = {
                    type: 'StandAloneSubmitted',
                    subType: 'Prequal',
                    leadInfo: {
                      FirstName: ca.buyer.personalInformation.firstName,
                      LastName: ca.buyer.personalInformation.lastName,
                      EmailAddress: ca.buyer.personalInformation.emailAddress,
                      HomePhone: ca.buyer.personalInformation.phoneNumber,
                      ZipCode: this.preQualForm.get('Zipcode').value
                    },
                    prequalAmt: this.preQualLeadInfo.prequalAmt
                  };
                  (window as any).postMessage(data, origin);
                }

              } catch (e) {/* istanbul ignore next */
                console.log(e);
              }
            }


            this.submitClicked = false;

            this.formSubmitted = true;
            if (ca.hideVoi && !ca.hyperianId && !ca.isIframe) {
              this.mapSavePreQualResponse(response);
            } else {
              this.mapPreQualResponse(response);
            }

          } else if (response.IsSuccess !== undefined && !response.IsSuccess) {

            this.submitClicked = false;
            this.showJackedModal = true;

            this.stopLoader();
            this.toggleNavigation();
            this.analyticsEventService.reportAnalyticsEvent(new PreQualFormEvents({
              type: PreQualFormEventConstant.FormFailure,
              componentName: ComponentName.PreQualComponent,
              isBuyNowPrequalSelected: this.preQualiFyMe,
              isVinAvailable: this.isVinAvailable,
              data: this.preQualLeadInfo,
            } as IPreQualEvent));
          } else {

            this.submitClicked = false;
            this.showJackedModal = true;
            this.stopLoader();
            if (this.analyticsEventService) {
              this.analyticsEventService.reportAnalyticsEvent(new PreQualFormEvents({
                type: PreQualFormEventConstant.FormFailure,
                componentName: ComponentName.PreQualComponent,
                isBuyNowPrequalSelected: this.preQualiFyMe,
                isVinAvailable: this.isVinAvailable,
                data: this.preQualLeadInfo,
              } as IPreQualEvent));
            }
          }
        }, error => {

          this.submitClicked = false;
          /* istanbul ignore next */
          console.log(error);
          this.showJackedModal = true;
          this.stopLoader();
          this.toggleNavigation();
          if (this.analyticsEventService) {
            this.analyticsEventService.reportAnalyticsEvent(new PreQualFormEvents({
              type: PreQualFormEventConstant.FormFailure,
              componentName: ComponentName.PreQualComponent,
              isBuyNowPrequalSelected: this.preQualiFyMe,
              isVinAvailable: this.isVinAvailable,
              data: this.preQualLeadInfo,
            } as IPreQualEvent));
          }
        });
      }

    }
  }

  shouldValidateLead(creditApp:any){
      const enableLeadValidation = !!this.config?.Sitecore?.CreditApplicationConfig?.PreQualificationInformation?.EnableLeadValidation; 
      const shouldValidate = enableLeadValidation && ((creditApp.buyer.personalInformation.emailAddress !== this.config?.Sitecore?.PreQualLeadInfo?.email) || 
            (this.normalizePhone(creditApp.buyer.personalInformation.phoneNumber) !== this.normalizePhone(this.config?.Sitecore?.PreQualLeadInfo?.phone)));
      return shouldValidate ? true : false; 
  }

  shouldValidateLeadRequest(request:any){
      const enableLeadValidation = !!this.config?.Sitecore?.CreditApplicationConfig?.PreQualificationInformation?.EnableLeadValidation; 
      const shouldValidateReq = enableLeadValidation && ((request.Email !== this.config?.Sitecore?.PreQualLeadInfo?.email) || 
            (this.normalizePhone(request.Phone ) !== this.normalizePhone(this.config?.Sitecore?.PreQualLeadInfo?.phone)));
      return shouldValidateReq ? true : false; 
  }  

  private normalizePhone(value: string): string {
    return (value || '').replace(/\D/g, '');
  }

  updateLeadInContext(creditApp: any) {
    if(this.config?.Sitecore?.PreQualLeadInfo) {
      this.config.Sitecore.PreQualLeadInfo.email = creditApp.buyer.personalInformation.emailAddress;
      this.config.Sitecore.PreQualLeadInfo.phone = creditApp.buyer.personalInformation.phoneNumber;
    }
  }
  
  async validateLead(lead:ILeadValidationRequest) {
      this.leadValidation_PhoneInvalid = false;        
      this.leadValidation_EmailInvalid = false;         
      const validation: ILeadValidationResponse = await getLeadValidationInfo(lead);
     
      const emailRiskLevel = validation?.Reasons?.Email?.RiskLevel 
      const phoneRiskLevel = validation?.Reasons?.Phone?.RiskLevel;
      const invalidPhone = phoneRiskLevel === 'High';
      let invalidEmail = emailRiskLevel=== 'High' || emailRiskLevel === 'Medium';
      if(emailRiskLevel === 'Medium' && this.lastSubmittedLead?.email === lead.email){
        invalidEmail = false;
      }
      this.lastSubmittedLead = JSON.parse(JSON.stringify(lead));
      const data = [];
      if(invalidPhone || invalidEmail)   {
            if(invalidEmail){
            data.push('Email');
            this.preQualForm?.get('Email')?.setValue('');
            this.leadValidation_EmailInvalid = true;   
            this.cd.detectChanges();
        } 
        if(invalidPhone){
          data.push('Phone');
           this.preQualForm?.get('Phone')?.setValue('');
          this.leadValidation_PhoneInvalid = true; 
          this.cd.detectChanges();            
        }  
        this.formInfoService.reportValidationPrequalFailure(data.join(','), this.isVinAvailable);             
        return {
          valid: false,
          validationParam: {
            enable: false,
            id: validation?.ValidationId
          }
        }; 
      } 

      return {
              valid: true,
              validationParam: {
                enable: false,
                id: validation?.ValidationId
              }
            };

  }

  emailFocusOut() {      
      this.leadValidation_EmailInvalid = false;    
  }
  phoneFocusOut() {
      this.leadValidation_PhoneInvalid = false;           
  }

  async submitPreQualApplicationStandAloneHL() {
    this.preQualForm.markAllAsTouched();
    this.preQualForm.markAsDirty();
    this.preQualForm.updateValueAndValidity();
    this.formSubmitAttempt = true;

    getBackButton();
    if (this.preQualForm.valid && this.preQualForm.dirty) {
      if (this.analyticsEventService) {
        this.analyticsEventService.reportAnalyticsEvent(new PreQualFormEvents({
          type: PreQualFormEventConstant.FormSubmitInitiated,
          componentName: ComponentName.PreQualComponent,
          isVinAvailable: this.isVinAvailable,
          data: this.preQualLeadInfo,
        } as IPreQualEvent));
      }
      const ca = { ...this.creditAppService.PreQualiFication };
      const legacy_ca = { ...this.creditAppService.LegacyCreditApplication };


      this.preQualForm.get('FirstName').setValue(this.preQualForm.get('FirstName').value.replace(/'+/g, '').trim());
      ca.buyer.personalInformation.firstName = this.preQualForm.get('FirstName').value.replace(/'+/g, '').trim();
      if (legacy_ca?.buyer?.personalInformation) {
        legacy_ca.buyer.personalInformation.firstName = this.preQualForm.get('FirstName').value.replace(/'+/g, '').trim();
        legacy_ca.buyer.personalInformation.lastName = this.preQualForm.get('LastName').value.replace(/'+/g, '').trim();
        legacy_ca.buyer.personalInformation.emailAddress = this.preQualForm.get('Email').value;
        legacy_ca.buyer.personalInformation.phoneNumber = this.preQualForm.get('Phone').value.match(/\d/g).join('');
        legacy_ca.buyer.personalInformation.currentAddress = {
          addressLine1: this.preQualForm.get('Address').value?.replace(/[^a-zA-Z0-9\s]/g, ''), //scrub invalid chars
          addressLine2: this.preQualForm.get('Address2').value?.replace(/[^a-zA-Z0-9\s]/g, ''), //scrub invalid chars
          city: this.preQualForm.get('City').value,
          postalCode: this.preQualForm.get('Zipcode').value,
          stateCode: this.preQualForm.get('State').value,
          yearsAtAddress: 0,
          monthsAtAddress: 0
        };
      }
      this.preQualForm.get('LastName').setValue(this.preQualForm.get('LastName').value.replace(/'+/g, '').trim());
      ca.buyer.personalInformation.lastName = this.preQualForm.get('LastName').value.replace(/'+/g, '').trim();
      if (this.preQualForm.get('MI').value !== null) {
        this.preQualForm.get('MI').setValue(this.preQualForm.get('MI').value.trim());
        ca.buyer.personalInformation.middleName = this.preQualForm.get('MI').value;
        if (legacy_ca?.buyer?.personalInformation) {
          legacy_ca.buyer.personalInformation.middleName = this.preQualForm.get('MI').value;
        }
      }
      ca.buyer.personalInformation.emailAddress = this.preQualForm.get('Email').value;
      ca.buyer.personalInformation.phoneNumber = this.preQualForm.get('Phone').value.match(/\d/g).join('');
      ca.buyer.personalInformation.dateOfBirth = this.preQualForm.get('DOB').value;
      ca.buyer.personalInformation.income = this.preQualForm.get('AnnualIncome').value;
      ca.buyer.personalInformation.monthlyMortgage = this.preQualForm.get('MortgageRent').value;
      ca.buyer.financialInformation.securityInformation.ssn = this.preQualForm.get('SSN').value;
      ca.buyer.personalInformation.currentAddress = {
        addressLine1: this.preQualForm.get('Address').value?.replace(/[^a-zA-Z0-9\s]/g, ''), //scrub invalid chars
        addressLine2: this.preQualForm.get('Address2').value?.replace(/[^a-zA-Z0-9\s]/g, ''), //scrub invalid chars
        city: this.preQualForm.get('City').value,
        postalCode: this.preQualForm.get('Zipcode').value,
        stateCode: this.preQualForm.get('State').value,
        yearsAtAddress: null,
        monthsAtAddress: null
      };


      if (this.isVinAvailable) {
        ca.voi.make = this.preQualLeadInfo.make;
        ca.voi.year = this.preQualLeadInfo.year;
        ca.voi.model = this.preQualLeadInfo.model;
        ca.voi.vin = this.preQualLeadInfo.vin;
        ca.voi.stockType = this.preQualLeadInfo.inventoryType;
        ca.voi.hyperionId = this.config.Sitecore.Hid ? this.config.Sitecore.Hid : this.preQualLeadInfo.HyperianId;
      } else {
        ca.hideVoi = true;
      }

      if (this.ymmtObj) {
        ca.voi.make = this.ymmtObj.make;
        ca.voi.year = this.ymmtObj.year;
        ca.voi.model = this.ymmtObj.model;
        ca.voi.trim = this.ymmtObj.trim;
        ca.voi.stockType = this.ymmtObj.stockType;
        ca.ymmtObj = this.ymmtObj;
        this.creditAppService.YMMTDetails$.next(this.ymmtObj);
      }

      ca.voi.isInvalidVin = this.invalidVin;
      if (this.preQualLeadInfo && this.preQualLeadInfo.vin) {
        ca.vin = this.preQualLeadInfo.vin || null;
      }
      if (this.preQualLeadInfo && this.preQualLeadInfo.HyperianId) {
        ca.hyperianId = this.preQualLeadInfo.HyperianId || null;
      }
      ca.isIframe = this.isIframe;

      
      if(this.shouldValidateLead(ca)){        
        let lead: ILeadValidationRequest = {
            firstName: ca.buyer.personalInformation.firstName,
            lastName: ca.buyer.personalInformation.lastName,
            email: ca.buyer.personalInformation.emailAddress,
            phone: ca.buyer.personalInformation.phoneNumber,
            hyperionId: ca.voi?.hyperionId || this.config?.Sitecore?.Hid || ca.hyperianId || ''
        };

        const leadValidationResponse  = await this.validateLead(lead);
        if(!leadValidationResponse?.valid) {
 
          this.submitClicked = false;            
          return false; 
        } 
        if(leadValidationResponse?.validationParam?.id) {
          ca.validation = leadValidationResponse.validationParam;
        }             
      } else {
        ca.validation = {
            enable: !this.config?.Sitecore?.CreditApplicationConfig?.PreQualificationInformation?.EnableLeadValidation ? true : false,
            id: null
        };
      }

      this.submitClicked = true;

      this.creditAppService.standAloneLeadTransactionHL(ca, this.SubPage, this.apiDomain).subscribe(response => {

        if (this.isBuyNow) {
          this.heapIoService.trackSubmit(response);
          this.heapIoService.track('Purchase', { dollars: 302, item: 'Buy Now' });
        }
        if (response.IsSuccess) {
          this.updateLeadInContext(ca);          
        }

        if (response.IsSuccess !== undefined && response.IsSuccess && !this.config?.Sitecore?.isLegacyCreditApp) {

          if (this.preQualLeadInfo && this.preQualLeadInfo.zipcode) {
            this.preQualLeadInfo.zipcode = this.preQualForm.get('Zipcode').value;
          }

          if (this.analyticsEventService) {
            this.analyticsEventService.reportAnalyticsEvent(new PreQualFormEvents({
              type: PreQualFormEventConstant.LeadSubmission,
              componentName: ComponentName.PreQualComponent,
              isBuyNowPrequalSelected: this.preQualiFyMe,
              isVinAvailable: this.isVinAvailable,
              data: this.preQualLeadInfo,
            } as IPreQualEvent));
          }

          if (this.preQualLeadInfo && this.preQualLeadInfo.prequalAmt) {
            this.preQualLeadInfo.prequalAmt = (ca.hideVoi && !ca.hyperianId && !ca.isIframe) ? this.setSavePrequalAmt(response) : this.setPrequalAmt(response);
          }
          if (this.isHeadless && response?.Data) {
            if (response?.Data?.prequalified === true) {
              this.preQualLeadInfo['prequalAmt'] = response?.Data?.amount ? response.Data.amount : 0;
            }
            else if (response?.Data?.PreQualifiedResponse && response?.Data?.PreQualifiedResponse?.PreQualifiedInformation) {
              this.preQualLeadInfo['prequalAmt'] = response?.Data?.PreQualifiedResponse?.PreQualifiedInformation?.PreQualifiedAmount ? response.Data.PreQualifiedResponse.PreQualifiedInformation.PreQualifiedAmount : 0;
            }
          }
          if (this.analyticsEventService) {
            this.analyticsEventService.reportAnalyticsEvent(new PreQualFormEvents({
              type: PreQualFormEventConstant.FormSuccess,
              componentName: ComponentName.PreQualComponent,
              isBuyNowPrequalSelected: this.preQualiFyMe,
              isVinAvailable: this.isVinAvailable,
              data: this.preQualLeadInfo,
            } as IPreQualEvent));
          }

          try {
            const preQualifyStatus: IPreQualEvent = {
              componentName: ComponentName.PreQualComponent,
              data: this.preQualLeadInfo,
              isVinAvailable: this.isVinAvailable,
              // tslint:disable-next-line: max-line-length
              type: this.preQualLeadInfo.prequalAmt > 0 ? PreQualFormEventConstant.PreQualApproved : PreQualFormEventConstant.PreQualDeclined
            };
            this.analyticsEventService.reportAnalyticsEvent(new PreQualFormEvents(preQualifyStatus));

            // Routing to SRP if no VIN in URL and not an iFrame
            if (!this.isIframe && !this.config.Sitecore.PreQualLeadInfo.vin && this.config.Sitecore && this.config.Sitecore.CreditApplicationConfig) {
              /* istanbul ignore next */
              let url: string = this.config.Sitecore.CreditApplicationConfig.PreQualificationInformation
                && this.config.Sitecore.CreditApplicationConfig.PreQualificationInformation.PrequalWithoutVOIRedirectsTo
                && this.config.Sitecore.CreditApplicationConfig.PreQualificationInformation.PrequalWithoutVOIRedirectsTo.Url;

              const searchRadius: number = this.config.Sitecore.CreditApplicationConfig.PreQualificationInformation
                && Number(this.config.Sitecore.CreditApplicationConfig.PreQualificationInformation.PrequalWithoutVOISearchRadius);
              /* istanbul ignore next */
              url = url || '/cars-for-sale';

              const prequalAmount = (ca.hideVoi && !ca.hyperianId && !ca.isIframe) ? this.setSavePrequalAmt(response) : this.setPrequalAmt(response);

              /* istanbul ignore next */
              if (url.indexOf('?') !== -1) {
                url += '&';
              } else {
                url += '?';
              }

              /* istanbul ignore next */
              // if (prequalAmount > 0) {
              //   // round to next 10000 with 10% more
              //   let max = Math.ceil((prequalAmount + (prequalAmount * 0.10)) / 10000) * 10000;
              //   if (max > 100000) {
              //     max = 100000;
              //   } else if (max <= 5000 && max > 2000) {
              //     max = 5000;
              //   } else if (max < 2000) {
              //     max = 2000;
              //   }
              //   url += `banner=prequal&sortdirection=1&fmn=1&fmx=${max}`;
              // } else {
              //   url += 'banner=prequal&sortdirection=0';
              // }
              url += 'banner=prequal&sortdirection=0';
              if (searchRadius) {
                url += `&dst=${searchRadius}`;
              }

              this.navigateToUrl(`${url}`);

              // dont show confirmation page, just redirect
              return;
            } else {
              const origin = `${(window as any).location.origin}`;
              const data = {
                type: 'StandAloneSubmitted',
                subType: 'Prequal',
                leadInfo: {
                  FirstName: ca.buyer.personalInformation.firstName,
                  LastName: ca.buyer.personalInformation.lastName,
                  EmailAddress: ca.buyer.personalInformation.emailAddress,
                  HomePhone: ca.buyer.personalInformation.phoneNumber,
                  ZipCode: this.preQualForm.get('Zipcode').value
                },
                prequalAmt: this.preQualLeadInfo.prequalAmt
              };
              (window as any).postMessage(data, origin);
            }

          } catch (e) {/* istanbul ignore next */
            console.log(e);
          }

          this.submitClicked = false;

          this.formSubmitted = true;
          if (ca.hideVoi && !ca.hyperianId) {
            this.mapSavePreQualResponse(response);
          } else {
            this.mapPreQualResponse(response);
          }

        } else if (response.IsSuccess !== undefined && response.IsSuccess && this.config?.Sitecore?.isLegacyCreditApp) {
          if (response?.Data?.LeadResponse) {
            this.creditAppService.StoreDetails$.next(response?.Data?.LeadResponse?.StoreInfo?.Name);
          }
          let nextComponent: IComponentDetails;
          nextComponent = {
            groupName: ComponentGroup.PersonalInfo,
            component: new StepComponent(
              PersonalInfoComponent,
              ComponentName.PersonalInfoComponent,
              ComponentGroup.PersonalInfo,
              true,
              StepType.Buyer
            ),
            componentName: ComponentName.PersonalInfoComponent
          };
          this.nextComponentService.loadComponent(nextComponent);
          document.dispatchEvent(new CustomEvent('DISABLE_YMMT_VEHICLE_SELECTION', {
            detail: {}
          }));

        } else if (response.IsSuccess !== undefined && !response.IsSuccess) {
      
          if (this.config.Sitecore.isLegacyCreditApp && response.IsSuccess === false && response.Data === null && response.Message === 'Could not determine the store to use') {
            this.creditAppConfigData.JackedMessage = this.creditAppConfigData.LeadRouteJackedMessage;
            this.creditAppConfigData.JackedTitle = this.creditAppConfigData.LeadRouteJackedTitle;
            this.creditAppConfigData.JackedImage = this.creditAppConfigData.LeadRouteJackedImage;
            this.showJackedModal = false;
          } else {
            this.showJackedModal = true;
          }

          this.submitClicked = false;
          this.stopLoader();
          this.analyticsEventService.reportAnalyticsEvent(new PreQualFormEvents({
            type: PreQualFormEventConstant.FormFailure,
            componentName: ComponentName.PreQualComponent,
            isBuyNowPrequalSelected: this.preQualiFyMe,
            isVinAvailable: this.isVinAvailable,
            data: this.preQualLeadInfo,
          } as IPreQualEvent));
        } else {
          this.submitClicked = false;
          this.showJackedModal = true;
          this.stopLoader();
          if (this.analyticsEventService) {
            this.analyticsEventService.reportAnalyticsEvent(new PreQualFormEvents({
              type: PreQualFormEventConstant.FormFailure,
              componentName: ComponentName.PreQualComponent,
              isBuyNowPrequalSelected: this.preQualiFyMe,
              isVinAvailable: this.isVinAvailable,
              data: this.preQualLeadInfo,
            } as IPreQualEvent));
          }
        }
      }, error => {
        this.submitClicked = false;
        /* istanbul ignore next */
        console.log(error);
        this.showJackedModal = true;
        this.stopLoader();
        if (this.analyticsEventService) {
          this.analyticsEventService.reportAnalyticsEvent(new PreQualFormEvents({
            type: PreQualFormEventConstant.FormFailure,
            componentName: ComponentName.PreQualComponent,
            isBuyNowPrequalSelected: this.preQualiFyMe,
            isVinAvailable: this.isVinAvailable,
            data: this.preQualLeadInfo,
          } as IPreQualEvent));
        }
      });
    }
  }

  navigateToUrl(url: string) {
    /* istanbul ignore next */
    setTimeout(() => {
      location.href = url;
    }, 0);
  }

  setPrequalAmt(response: PreQualificationResponseType): number {
    return (response.Data && response.Data.PreQualifiedResponse
      && response.Data.PreQualifiedResponse.PreQualifiedInformation) ?
      response.Data.PreQualifiedResponse.PreQualifiedInformation.PreQualifiedAmount : 0;
  }

  setSavePrequalAmt(response): number {
    return response?.Data && response?.Data?.prequalified ? response?.Data?.amount : 0;
  }

  mapPreQualResponse(response: PreQualificationResponseType) {
    if (response.Data) {
      this.disableEmailField = true;
      const preQualResponse = response.Data.PreQualifiedResponse;
      if (preQualResponse && preQualResponse.PreQualifiedInformation &&
        preQualResponse.PreQualifiedInformation.PreQualifiedAmount > 0) {
        this.mapSuccess(preQualResponse.PreQualifiedInformation.PreQualifiedAmount);
      } else {
        this.mapFailure();
      }
    } else {
      this.mapFailure();
    }
  }

  mapSavePreQualResponse(response) {
    if (response.Data) {
      this.disableEmailField = true;
      if (response.Data.prequalified && response.Data.amount > 0) {
        if (response?.Data?.match == 1) {
          window.location.href = this.config?.Sitecore?.CreditApplicationConfig?.PreQualificationInformation?.PrequalWithoutVOIRedirectsTo?.Url || '/cars-for-sale';
        } else {
          this.mapSuccess(response.Data.amount);
        }
      } else {
        this.mapFailure();
      }
    } else {
      this.mapFailure();
    }
  }

  get disableEmailFieldFn() {
    if (this.config && this.config.Sitecore && this.config.Sitecore.PreQualLeadInfo && this.config.Sitecore.PreQualLeadInfo.leadid) {
      if ((!this.isBuyNow) || (this.config.Sitecore.PreQualLeadInfo.leadid === 0 && !this.disableEmailField &&
        this.config.Sitecore.PreQualLeadInfo.email === null)) {
        return null;
      } else {
        return true;
      }
    }
  }

  mapFailure() {
    this.showConfirmation = true;
    try {
      if (this.isBuyNow && (window as any).buynow) {
        (window as any).buynow.navigation.hideNext();
        (window as any).buynow.navigation.hidePrev();
      }
    } catch (e) {/* istanbul ignore next */
      console.log(e);
    }

    this.outcome = {
      status: false,
      prequalAmt: 0,
      firstName: this.preQualForm.get('FirstName').value
    };
  }

  mapSuccess(amount: number) {
    this.showConfirmation = true;
    try {
      if (this.isBuyNow && (window as any).buynow) {
        (window as any).buynow.navigation.hideNext();
        (window as any).buynow.navigation.hidePrev();
      }
    } catch (e) {/* istanbul ignore next */
      console.log(e);
    }
    this.outcome = {
      status: true,
      prequalAmt: amount,
      firstName: this.preQualForm.get('FirstName').value
    };
  }

  stopLoader() {
    try {
      /* istanbul ignore next */
      this.ngxService.stopAllLoader('creditApplicationPreQual');
    } catch (e) {/* istanbul ignore next */
      console.error(e);
    }
  }

  async getBrowserZipcode() {
    let zipcode;
    try {
      const location = await (window as any).AN?.locationService?.getBrowserLocation();
      if (location?.ValidPostalCode) {
        zipcode = location.PostalCode;
      }
    }
    catch (error) {
      zipcode = (window as any).AN?.locationService?.getLocation()?.zipCode || '';
    }

    if (zipcode) {
      this.preQualForm.get('Zipcode').setValue(zipcode);
      this.cd.detectChanges();
    }

  }

  backClicked(event: boolean) {
    this.showConfirmation = false;
    try {
      if (this.isBuyNow && (window as any).buynow) {
        (window as any).buynow.navigation.showNext();
        (window as any).buynow.navigation.showPrev();
      }
    } catch (e) {/* istanbul ignore next */
      console.log(e);
    }

    if (this.IsStandAlonePreQual) {
      this.SSN.setValue('');
      this.DOB.setValue('');
    } else {
      this.SSN.reset();
      this.DOB.reset();
      this.Zipcode.reset();
      this.Address.reset();
      this.City.reset();
      this.State.reset();
      this.preQualForm.controls.PreQualiFyMe.setValue(true);
    }
    this.updateFormValidators();
    this.formSubmitAttempt = false;
    this.formSubmitted = false;

    if ((this.isBuyNow || this.IsStandAlonePreQual) && this.config && this.config.Sitecore) {
      if (this.config.Sitecore.IsAzureMapsEnabled) {
        /* istanbul ignore next */
        this.loadAzureMaps();
      } else {
        this.loadBingApi();
      }
    }

  }

  loadBingApi() {
    /* istanbul ignore else*/
    /*  if (this.config.Sitecore && this.config.Sitecore.BingKey) {
        this.getScript(
          'https://www.bing.com/api/maps/mapcontrol?key=' + this.config.Sitecore.BingKey, () => { });
      }*/
    /* istanbul ignore next */
    if (this.config && this.config.Sitecore && this.config.Sitecore.BingKey) {
      BingMapsService.load()
        .then(res => {
          this.mapReady = true;
        }).then(() => {
          setTimeout(() => {
            /* istanbul ignore else */
            if (this.mapReady && typeof Microsoft !== 'undefined') {
              this.loadMap();
            }
          }, 1);
        });
    }
  }

  /* istanbul ignore next */
  loadMap() {
    Microsoft.Maps.loadModule('Microsoft.Maps.AutoSuggest', {
      callback: this.onLoadBingMaps.bind(this),
      errorCallback: this.onErrorBingMaps.bind(this),
      credentials: this.config.Sitecore.BingKey
    });
  }

  @HostListener('document:readystatechange', ['$event'])
  onReadyStateChanged(event) {
    if (event.target.readyState === 'complete') {
      if (this.config.Sitecore && this.config.Sitecore.IsAzureMapsEnabled && (this.preQualiFyMe || this.IsStandAlonePreQual)) {
        /* istanbul ignore next */
        this.loadAzureMaps();
      }
      if (
        (this.isBuyNow || this.IsStandAlonePreQual)
        && this.config.Sitecore
        && !this.config.Sitecore.IsAzureMapsEnabled
        && this.config.Sitecore.BingKey
      ) {
        /* istanbul ignore next */
        setTimeout(() => {
          if (typeof Microsoft !== 'undefined' && Microsoft && Microsoft.Maps) {
            Microsoft.Maps.loadModule('Microsoft.Maps.AutoSuggest', {
              callback: this.onLoadBingMaps.bind(this),
              errorCallback: this.onErrorBingMaps.bind(this)
            });
          }
        }, 1);

      }
    }
  }

  /* istanbul ignore next */
  onLoadBingMaps() {
    const location = new Microsoft.Maps.Location(this.coordinates.Latitude, this.coordinates.Longitude);
    const options = { maxResults: 3, countryCode: 'US', placeSuggestions: false, userLocation: location };
    const manager = new Microsoft.Maps.AutosuggestManager(options);
    const input = '#Address';
    const boxContainer = '#searchBoxContainer';
    /* istanbul ignore next */
    if (document.querySelector(input) && document.querySelector(boxContainer)) {
      /* istanbul ignore next */
      manager.attachAutosuggest(input, boxContainer, this.selectedSuggestionAddress.bind(this));
    } else {
      console.error('Elements for Bing AutoSugest not found');
    }
  }

  onErrorBingMaps(message) {
    /* istanbul ignore next */
    console.log(message);
  }

  selectedSuggestionAddress(suggestionResult) {
    this.Address.setValue(suggestionResult.address && suggestionResult.address.addressLine || '');
    this.City.setValue(suggestionResult.address && suggestionResult.address.locality || '');
    this.State.setValue(this.getState(suggestionResult) || '');
    this.Zipcode.setValue(suggestionResult.address && suggestionResult.address.postalCode || '');
    setTimeout(() => {
      this.Address.setValue(suggestionResult.address && suggestionResult.address.addressLine || '');
    }, 1);
  }


  getState(suggestionResult: any) {
    let suggestedState: any;
    let state: string;
    if (suggestionResult && suggestionResult.address && suggestionResult.address.adminDistrict !== '') {
      if (this.states) {
        suggestedState = this.states.filter(s => s.Details.trim() === suggestionResult.address.adminDistrict.trim());
        state = suggestedState.length > 0 ? suggestedState[0].Value : '';
      }
    }
    return state;
  }

  @HostListener('window:AzureMapsZipUpdate', ['$event'])
  onAzureMapsZipUpdate(event) {
    /* istanbul ignore next */
    if (event && event.detail) {
      this.Address.setValue(event.detail.address);
      this.City.setValue(event.detail.city);
      this.State.setValue(event.detail.state);
      this.Zipcode.setValue(event.detail.zip);
    }
  }

  getScript(src: string, callback: () => void) {
    const d = document;
    const o = { callback: callback || (() => { }) };
    let s: any;
    let t: any;

    if (typeof src === 'undefined') {
      return;
    }
    /* istanbul ignore next */
    s = d.createElement('script');
    /* istanbul ignore next */
    s.language = 'javascript';
    /* istanbul ignore next */
    s.type = 'text/javascript';
    /* istanbul ignore next */
    s.charset = 'utf-8';
    /* istanbul ignore next */
    s.src = src;
    /* istanbul ignore next */
    if (typeof o.callback === 'function') {
      /* istanbul ignore next */
      if (d.addEventListener) {
        s.addEventListener(
          'load',
          () => {
            o.callback();
          },
          false
        );
      } else {
        // old IE support
        s.onreadystatechange = function () {
          if (this.readyState === 'complete' || this.readyState === 'loaded') {
            this.onreadystatechange = null;
            /* istanbul ignore next */
            o.callback();
          }
        };
      }
    }
    /* istanbul ignore next */
    t = d.getElementsByTagName('script')[0];
    /* istanbul ignore next */
    t.parentNode.insertBefore(s, t);
  }

  updateCtas() {
    try {
      (window as any)?.standalonePrequal?.updateCtasPosition();
    } catch (error) {/* istanbul ignore next */
      console.log(error);
    }
  }

  @HostListener('window:message', ['$event'])
  onMessage(event) {
    try {
      if (!this.IsStandAlonePreQual || !event.data ||
        event.origin !== `${(window as any).location.origin}`) {
        return;
      }
      if (event.data.type === 'StandAloneBack') {
        this.backClicked(true);
        this.updateCtas();
      }
      if (event.data.type === 'StandAloneGetLowerPrice') {
        this.leadFormModalService.open(true);
        this.openLowerPriceModal = true;
      }
      /* istanbul ignore next */
      if (event.data.type === 'priceDetailsModalLegacy') {
        this.modalService.open(PriceDetailsModalComponent, {
          title: this.config.Sitecore?.PriceDetails?.Header,
          pricingStack: this.config.Sitecore?.PricingStack,
          priceItemsLabels: this.config.Sitecore?.PriceDetails?.PriceItemsLabels
        }, {
          maxWidth: '425px'
        });
      }
      if (event.data.type === 'openTooltip') {
        this.modalService.open(BaseTooltipModalComponent, {
          title: event.data.title,
          message: event.data.text
        }, {
          maxWidth: '300px',
          backdropColor: 'transparent',
          mobileFullSize: false
        });
      }
    } catch (e) {
      /* istanbul ignore next */
      console.log(e);
    }
  }

}
